import { BeforeCloseEventArgs, DialogComponent } from '@syncfusion/ej2-react-popups';
import L from 'leaflet';
import React from 'react';
import { Circle, Marker, Popup } from 'react-leaflet';
import * as Inovx from '@shared';
import FacilityActions from '../actions/FacilityActions';
const { useState} = React;

var UrlUtilities = Inovx.Shared.Common.UrlUtilities;
var InovxControls = Inovx.Shared.Controls;
var SystemActions = Inovx.Shared.System.Actions;

L.Icon.Default.prototype.options.imagePath = `${UrlUtilities.getBaseApplicationUrl()}/images/leaflet/`

interface XMLDataProps {
    data: IFacilityAdapterConfiguration,
    onSave?: (data:any) => void;
    
}

const XMLEditor = (props: XMLDataProps) => {
    const [xmlData, setXmlData] = React.useState<IFacilityAdapterConfiguration>(props.data);
    const [xmlError, setXMLError] = React.useState<boolean>(false);
    const [hasChange, setChange] = React.useState<boolean>(false);
    const isValidXML = (xmlString: string) => {
        if (xmlData.IsRequired) {
            const parser = new DOMParser();
            const xmlDoc = parser.parseFromString(xmlString, 'application/xml');
            return xmlDoc.getElementsByTagName('parsererror').length === 0;
        } else if (!xmlString || xmlString === '') return true;
    }

    const saveXML = () => {
        if (isValidXML(xmlData.Value)) {
            setXMLError(false);
            props.onSave(xmlData)
            FacilityActions.toggleXMLEditor(false);
        } else {
            setXMLError(true);
        }
    }
    const toggleXMLEditor = () => {
        FacilityActions.toggleXMLEditor(false);
    }
    const close = () => {
        if (hasChange) {
            SystemActions.displaySaveChangesDialog({
                message: InovxLoader.t("common:msgBox.saveChanges"),
                confirmCallback: saveXML,
                cancelCallback: toggleXMLEditor
            });

        } else {
            toggleXMLEditor();
        }
    }
    const handleBeforeClose = (arg: BeforeCloseEventArgs) => {
        if (hasChange) {
            arg.cancel = true;
            close();
        } else {
            close();
        }
    }
    const handleChange = (e: any) => {
        if (xmlData.Value !== e.target.value) {
            setChange(true);
        } else {
            setChange(false);
        }
        setXmlData({ ...xmlData, Value: e.target.value })
    }
    const header = () => {
        return (<div>
            <div className="e-icon-settings dlg-template">{InovxLoader.t('facility:form.editXml')}: '{props.data.DisplayName}'</div>
        </div>);
    }
    const footerTemplate = () => {
        return (<div>
            <div className="d-flex j-cc pb-10px">
                <div>
                    <a id="facilityApp-save-btn" onClick={saveXML} className="btn btn-primary ">{InovxLoader.t("facility:preferences.saveButton")}</a>
                </div>
                <div className="ml-1">
                    <a id="facilityApp-cancel-btn" onClick={close} className="btn btn-default">{InovxLoader.t("facility:preferences.cancelButton")}</a>
                </div>
            </div>
        </div>);
    }

    return (
        <DialogComponent target={'#app'} width='80%' header={header} footerTemplate={footerTemplate} showCloseIcon={true} visible={true} close={close} cssClass="xmlEditor" isModal={true} closeOnEscape={false} beforeClose={handleBeforeClose} zIndex={110000}>
            <div className="dialogContent">

                <InovxControls.FormField title={""} inputName={xmlData.Name} className={`${xmlError ? 'has-error' : ''}`}>
                    <textarea onChange={handleChange} value={xmlData.Value} className="form-control" name={xmlData.Name} placeholder={InovxLoader.t("facility:message.xmlPlaceholder")} rows={20} />
                </InovxControls.FormField>
                {xmlError && <div className="mt-5px text-danger">{InovxLoader.t("facility:message.pleaseEnterValidXMLFormat")}</div>}
            </div>
        </DialogComponent>
    );
};

export default XMLEditor;
